export const Spinner = ({
  className = "",
  color = "#00bbd6",
  thickness = 2,
  size = 32,
  label,
}) => {
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  // Visible arc length (~2/3 of circumference)
  const dash = c * (2 / 3);

  return (
    <div
      className={`${className} flex justify-center flex-col flex-1 items-center space-y-2 z-30`}
    >
      <svg
        className="lds-ring-svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        role="status"
        aria-label={label || "Loading"}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={thickness}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c - dash}`}
        />
      </svg>
      {label ? <div className="text-xs">{label}</div> : null}
    </div>
  );
};

export default Spinner;
